import { useCaptchaConfig } from "@casino/client/context/CaptchaConfig/CaptchaConfigContext";
import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useSite from "@casino/legacy/client/hooks/useSite";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

type Args = {
  isRegister?: boolean;
};

const useReCaptchaV3 = ({ isRegister }: Args) => {
  const { isBridgeSite } = useSite();
  const isRecaptchaV3Enabled = useFeature("isRecaptchaV3Enabled");
  const { isLoginCaptchaRequired, isRegistrationCaptchaRequired } =
    useCaptchaConfig();
  const isCaptchaRequired = isRegister
    ? isRegistrationCaptchaRequired
    : isLoginCaptchaRequired;
  const isRecaptchaV3 =
    isRecaptchaV3Enabled && !isCaptchaRequired && !isBridgeSite;
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getV3Token = async () => {
    if (executeRecaptcha && isRecaptchaV3) {
      return (await executeRecaptcha()) ?? "";
    }
    return "";
  };
  return { getV3Token, captchaVersion: isRecaptchaV3 ? "v3" : "v2" };
};

export default useReCaptchaV3;
